window.JobSearch = (jobs) => {
	return {
		allJobs: JSON.parse(jobs),
		filteredJobs: JSON.parse(jobs),
		paginatedJobs: [],
		currentJobs: [],
		location: 'Select Location',
		keywords: '',
		page: 1,
		pagination: [],

		/**
		 * Resets location and keywords to their default values and submit
		 * these new values to display all jobs.
		 *
		 * Calls queryFilters().
		 */
		clearFilters() {
			this.location = 'Select Location';
			this.keywords = '';

			this.queryFilters();
			this.displayPage(1);
		},

		/**
		 * Filters the allJobs array to match the given values in location
		 * and keywords. Places the filtered jobs in the FilteredJobs array.
		 *
		 * Calls paginateFilteredJobs().
		 */
		queryFilters() {
			// No filters
			if (this.location == 'Select Location' && this.keywords == '') {
				this.filteredJobs = this.allJobs;

			} else {
				var tempJobs = this.allJobs;

				// Location filter
				if (this.location != 'Select Location') {
					tempJobs = this.allJobs.filter((job) => {
						return job.location.toLowerCase().startsWith(this.location.toLowerCase());
					});
				}

				// Keyword filter
				if (this.keywords != '') {
					const fuseOptions = {
						keys: ['url', 'job_id', 'title', 'country', 'location', 'company'],
						minMatchCharLength: 3,
						threshold: 0.4
					};

					const fuse = new Fuse(tempJobs, fuseOptions);
					const results = fuse.search(this.keywords);

					tempJobs = [];
					results.forEach(job => {
						tempJobs.push(job['item']);
					});
				}
				this.filteredJobs = tempJobs;
			}

			this.paginateFilteredJobs();
		},

		/**
		 * Breaks the filteredJobs array up into an array of arrays of 8 or
		 * less jobs. These represent the paginated "pages".
		 */
		paginateFilteredJobs() {
			var tempJobs = []
			var jobPage  = []
			var counter  = 0;

			if (this.filteredJobs == undefined) {
				this.paigination = null;
			}

			for (let i = 0; i < this.filteredJobs.length; i++) {
				const job = this.filteredJobs[i];

				if (counter == 8) {
					counter = 0;
					tempJobs.push(jobPage);
					jobPage = [];
					jobPage.push(job);
				} else {
					jobPage.push(job);
				}

				if (i == this.filteredJobs.length - 1) {
					tempJobs.push(jobPage)
				}

				counter++;
			}

			this.paginatedJobs = tempJobs;

			this.getPagination();
		},

		/**
		 * Creates an array of the displayed pagination buttons inclusing the
		 * next and previous arrows, current page number, and the page numbers in between.
		 */
		getPagination() {
			const pagination = [];
			var page         = this.page;
			var lastPage     = this.paginatedJobs.length;

			pagination['current'] = page;
			pagination['total']   = lastPage;
			pagination['prev']    = page == 1 ? '' : page - 1;
			pagination['pages']   = [];

			// Base case for only 1 page
			if (lastPage == 1) {
				pagination['pages'].push({'title': "1"});

			} else {
				// Create .pages mapping
				pagination['pages'].push({'title': "1"});
				for (let i = page - 2; i <= page + 2; i++) {
					if (i != 1 && i != lastPage && !(i < 1) && !(i > lastPage)) {
						pagination['pages'].push({'title': String(i)});
					}
				}
				pagination['pages'].push({'title': String(lastPage)});

				// Add connecting items to the beginning of the mapping
				if (pagination['pages'][1]['title'] == "3") {
					pagination['pages'].splice(1, 0, {'title': "2"});
				}
				if (pagination['pages'][1]['title'] != "2") {
					pagination['pages'].splice(1, 0, {'title': "..."});
				}
				// Add connecting items to the end of the mapping
				var endPage = parseInt(pagination['pages'][pagination['pages'].length-2]['title']);
				if (endPage == lastPage - 2) {
					pagination['pages'].splice(-1, 0, {'title': lastPage - 1});
				} else {
					if (endPage != lastPage - 1) {
						pagination['pages'].splice(-1, 0, {'title': "..."});
					}
				}
			}

			// Create .next mapping
			pagination['next'] = page == lastPage ? '' : page + 1;

			this.pagination = pagination;
		},

		/**
		 * Grabs the section of the array for the desired page number and sets
		 * the currentJobs array to the new jobs to display.
		 *
		 * @param {int} page - the paginated results page to display. Will be
		 * used as an index of the paginatedJobs array.
		 */
		displayPage(page) {
			this.page = page;
			this.getPagination();
			this.currentJobs = this.paginatedJobs[this.page - 1];
		},

		/**
		 * Function to run on init.
		 */
		init() {
			this.paginateFilteredJobs();
			this.displayPage(1);
		}
	};
};
